import React from 'react';
import ReactTooltip, { Effect, Place } from 'react-tooltip';

interface TooltipProps {
  id: string;
  place?: Place;
  effect?: Effect;
  message: string;
}
const Tooltip: React.FC<TooltipProps> = ({
  id,
  place = 'top',
  effect = 'solid',
  message
}) => (
  <ReactTooltip place={place} effect={effect} id={id}>
    <div className="max-w-xs">
      <p>{message}</p>
    </div>
  </ReactTooltip>
);

export default Tooltip;
